export default "__VITE_ASSET__BLc570u0__"